import React, { InputHTMLAttributes, ReactNode } from 'react'

import { useField } from 'formik'
import classNames from 'classnames'

import { FieldError } from '@components/form/field-error'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'

type InputProps = FieldProps &
  Omit<InputHTMLAttributes<HTMLInputElement>, 'onBlur'>

export const Input = ({
  name,
  label,
  className,
  container,
  onChange,
  error,
  withoutError = false,
  leftIcon,
  ...rest
}: InputProps) => {
  const [field, meta] = useField<string>(name)

  return (
    <div {...container}>
      {label}
      <div
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        style={{
          paddingLeft: leftIcon ? '0.5rem' : null
        }}
      >
        {leftIcon && <div>{leftIcon}</div>}
        <input
          name={name}
          {...field}
          onChange={event => {
            field.onChange(event)
            onChange && onChange(event)
          }}
          className="w-full"
          {...rest}
        />
      </div>
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
